var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-container"},[_c('header',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('Button',{attrs:{"className":"--secondary --outline --mini --big-text","onclick":_vm.close}},[_c('font-awesome-icon',{attrs:{"icon":['far','times']}})],1)],1),_c('main',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }